import { render, staticRenderFns } from "./ProgramForm.vue?vue&type=template&id=0cf5e066&scoped=true&"
import script from "./ProgramForm.vue?vue&type=script&lang=js&"
export * from "./ProgramForm.vue?vue&type=script&lang=js&"
import style0 from "./ProgramForm.vue?vue&type=style&index=0&id=0cf5e066&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf5e066",
  null
  
)

export default component.exports